export default "__VITE_ASSET__f49a36d5__"